
<div mat-dialog-container>
  <div class="mat-dialog-header-content">
    <mat-icon class="{{ 'icon ' + data.messageType + '-icon' }}">{{
      icons[data.messageType].icon
    }}</mat-icon>
  </div>
  <div class="mat-dialog-header-content">
    <h1>{{ data.messageTitle }}</h1>
  </div>
  <h3>{{ "DIALOGMESSAGEACTIVITY.CARD.ADDTOGRADEMSG2" | translate }}{{activityName}}{{ "DIALOGMESSAGEACTIVITY.CARD.ADDTOGRADEMSG3" | translate }}</h3>
  <!-- <mat-form-field appearance="outline" class="mat-dialog-content" >
      <mat-label>{{'LESSONS.LESSON'|translate}}</mat-label>
      <mat-select [formControl]="lessonsForm" multiple disableOptionCentering >

        <mat-select-trigger >

          <mat-chip-list  #lessonList aria-label="Selección de Asignatura">
            <mat-chip *ngFor="let lesson of lessonsForm.value" [removable]="true" (removed)="removeLesson(lesson)">
              {{lesson.name}}
              <mat-icon matChipRemove *ngIf="true">cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>

        </mat-select-trigger> 
        <mat-option *ngFor="let lesson of filteredLessons | async" [value]="lesson" >{{lesson.name}}</mat-option>

      </mat-select>

    </mat-form-field> -->
  <!-- {{ lessonsForm.value | json }} -->
 <form [formGroup]="activityGradeForm">
    <mat-form-field appearance="outline" class="mat-dialog-content">
      <mat-label>{{ "LESSONS.LESSON" | translate }}</mat-label>
      <mat-select [formControl]="activityGradeForm.get('lessonsF')" multiple disableOptionCentering #select>
        <mat-select-trigger>
          <mat-chip-list #lessonList aria-label="Selección de Asignatura">
            <mat-chip
              *ngFor="let lesson of activityGradeForm.get('lessonsF').value" [removable]="true" (removed)="removeLesson(lesson)">
              {{ lesson.name }}
              <mat-icon matChipRemove *ngIf="true">cancel</mat-icon>
            </mat-chip>
            <!-- <input
            placeholder="nueva clase..."
            #lessonInput
            formControlName="lessons"
            [matAutocomplete]="lessonSelect"
            [matChipInputFor]="lessonList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (matChipInputTokenEnd)="addLesson($event)"> -->
          </mat-chip-list>
        </mat-select-trigger>
          <!-- <mat-autocomplete #lessonSelect="matAutocomplete" (optionSelected)="lessonSelected($event)"> -->
          
            <mat-option
            *ngFor="let lesson of filteredLessons | async"
            [value]="lesson"
          >
            {{ lesson.name }}
          </mat-option>
          <hr>
          <button style="font-size: medium;text-align: left;" mat-flat-button fxFill (click)="createNewLesson()">Create Lesson</button>
          <mat-hint *ngIf="false">Hint</mat-hint>
        
      </mat-select>
    </mat-form-field>
     </form>
    <!-- <div *ngIf="activityGradeForm.get('lessonsF').value!=null">
    {{ activityGradeForm.get('lessonsF').value | json }}
  </div> -->
  <div mat-dialog-actions align="end">
    <button
      mat-flat-button
      color="primary"
      [mat-dialog-close]="lessons2Id()"
      cdkFocusInitial
    >
      {{ "MENU_CARD.ACCEPT" | translate }}
    </button>
    <button
      mat-flat-button
      *ngIf="data.messageType === 'question' || data.messageType === 'warning'"
      color="accent"
      [mat-dialog-close]="false"
      (click)="closeMe()"
    >
      {{ "MENU_CARD.CANCEL" | translate }}
    </button>
    <button
      mat-flat-button
      *ngIf="data.messageType !== 'question' && data.messageType !== 'warning'"
      color="primary"
      [mat-dialog-close]="true"
      (click)="closeMe()"
    >
      {{ "MENU_CARD.CANCEL" | translate }}
    </button>
  </div>
 
</div>

